// directives to be used in tags, like attributes and should be written as v-directiveName

import { nextTick } from "vue";

const directives = {
    uppercase: {
        update(element: HTMLInputElement) {
            if (!!element) {
                element.value = element.value.toUpperCase();
            }
        }
    },
    lowercase: {
        update(element: HTMLInputElement) {
            if (!!element) {
                element.value = element.value.toLowerCase();
            }
        }
    },
    "not-blank": {
        bind(element: HTMLInputElement) {
            if (!!element) {
                element.oninput = (e) => {
                    element.value = element.value.trimLeft();
                };
            }
        }
    },
    focus: {
        mounted(el: HTMLElement, binding) {
            const shouldFocus = binding.value !== false; // undefined → true

            if (!shouldFocus) return;

            nextTick(() => {
                if (el.offsetParent !== null && typeof el.focus === "function") {
                    el.focus();
                }
            });
        },
        updated(el: HTMLElement, binding) {
            const shouldFocus = binding.value !== false;
            const wasAlreadyActive = binding.oldValue !== false;

            if (!shouldFocus || wasAlreadyActive) return;

            nextTick(() => {
                if (el.offsetParent !== null && typeof el.focus === "function") {
                    el.focus();
                }
            });
        }
    }
};

export const inputDirectives = directives;
